import { useState, useEffect, useRef } from 'react';

export const useOrderEanValidation = (selectedOrder, invoiceData, printType) => {
  const [eanInputs, setEanInputs] = useState([""]);
  const [eanValidated, setEanValidated] = useState([false]);
  const eanRefs = useRef([]);

  useEffect(() => {
    if (
      !selectedOrder ||
      !invoiceData ||
      !invoiceData.shipping ||
      !Array.isArray(invoiceData.shipping.items_gtin)
    ) {
      setEanInputs([""]);
      setEanValidated([false]);
      return;
    }

    // Initialize arrays when invoice data changes or when order changes
    setEanInputs(Array(invoiceData.shipping.items_gtin.length).fill(""));
    setEanValidated(Array(invoiceData.shipping.items_gtin.length).fill(false));
  }, [invoiceData, selectedOrder?.shippingId || selectedOrder?._id]);

  const onEanInputChange = (index, value) => {
    setEanInputs((prev) => {
      const arr = [...prev];
      arr[index] = value;
      return arr;
    });
    
    if (
      printType === "detalhada" &&
      selectedOrder &&
      invoiceData &&
      invoiceData.shipping &&
      invoiceData.shipping.items_gtin
    ) {
      const expectedEan = invoiceData.shipping.items_gtin[index]?.gtin_code;
      setEanValidated((prev) => {
        const arr = [...prev];
        arr[index] = expectedEan && value.trim() === expectedEan;
        return arr;
      });
    }
  };

  const clearEanInputs = () => {
    if (
      selectedOrder &&
      invoiceData &&
      invoiceData.shipping &&
      Array.isArray(invoiceData.shipping.items_gtin)
    ) {
      setEanInputs(Array(invoiceData.shipping.items_gtin.length).fill(""));
      setEanValidated(Array(invoiceData.shipping.items_gtin.length).fill(false));
    }
  };

  const handleEanKeyDown = (idx, e, handlePrintWithReprintCheck, selectNextOrder) => {
    if (e.key === "Enter") {
      if (
        selectedOrder &&
        printType === "detalhada" &&
        invoiceData &&
        invoiceData.shipping &&
        Array.isArray(invoiceData.shipping.items_gtin)
      ) {
        if (eanValidated[idx]) {
          const nextIdx = idx + 1;
          if (eanRefs.current[nextIdx]) {
            eanRefs.current[nextIdx].focus();
          } else {
            if (eanValidated.every(Boolean)) {
              handlePrintWithReprintCheck();
              setTimeout(() => {
                selectNextOrder();
              }, 300);
            }
          }
        }
      }
    }
  };

  useEffect(() => {
    if (
      selectedOrder &&
      printType === "detalhada" &&
      invoiceData &&
      invoiceData.shipping &&
      Array.isArray(invoiceData.shipping.items_gtin) &&
      eanRefs.current[0]
    ) {
      setTimeout(() => {
        eanRefs.current[0]?.focus();
      }, 100);
    }
  }, [selectedOrder, printType]);

  return {
    eanInputs,
    eanValidated,
    eanRefs,
    onEanInputChange,
    clearEanInputs,
    handleEanKeyDown,
  };
};